/**
 * Hook: gửi join/leave (visitor + geo) lên PieSocket khi user vào/rời trang.
 * Dùng cho trang chính VNA2 (/) và Client page (/client) để dashboard biết ai đang xem.
 */

import { useEffect, useRef, useState } from "react";
import {
  createVisitorSocket,
  generateVisitorId,
  getGeoLocation,
  type VisitorInfo,
  type VisitorSocketMessage,
} from "../lib/visitor-socket";

export function useVisitorPresence(): { status: string } {
  const visitorRef = useRef<VisitorInfo | null>(null);
  const wsRef = useRef<WebSocket | null>(null);
  const [status, setStatus] = useState("Detecting location...");

  useEffect(() => {
    const visitorId = generateVisitorId();

    getGeoLocation().then((geo) => {
      const visitor: VisitorInfo = {
        id: visitorId,
        ip: geo.ip,
        city: geo.city,
        country: geo.country,
        lat: geo.lat,
        lon: geo.lon,
        timestamp: Date.now(),
      };
      visitorRef.current = visitor;
      setStatus(`Located: ${geo.city}, ${geo.country}`);

      const ws = createVisitorSocket();
      wsRef.current = ws;

      ws.onopen = () => {
        const msg: VisitorSocketMessage = { type: "join", visitor };
        ws.send(JSON.stringify(msg));
        setStatus(`Connected — ${geo.city}, ${geo.country}`);
      };
    });

    const handleLeave = () => {
      if (wsRef.current && visitorRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        const msg: VisitorSocketMessage = { type: "leave", visitor: visitorRef.current };
        wsRef.current.send(JSON.stringify(msg));
      }
    };

    window.addEventListener("beforeunload", handleLeave);
    return () => {
      window.removeEventListener("beforeunload", handleLeave);
      handleLeave();
      wsRef.current?.close();
    };
  }, []);

  return { status };
}
